/**
 * Minimal browser-safe logger that mirrors the server logger interface
 * without importing Node.js built-ins (which breaks client-side bundling).
 */
export const clientLogger = {
  error: (ctx: Record<string, unknown>, msg: string) => {
    console.error(`[use-workspace-assistant] ${msg}`, ctx);
  },
  info: (ctx: Record<string, unknown>, msg: string) => {
    console.info(`[use-workspace-assistant] ${msg}`, ctx);
  },
};